import { Configuration, PopupRequest } from '@azure/msal-browser';

declare global {
  interface Window {
    __APP_CONFIG__?: {
      azureClientId?: string;
      azureTenantId?: string;
      /** Public base URL of the Trigger service. See WebhookSecurityModal. */
      triggerUrl?: string;
    };
  }
}

const cfg = window.__APP_CONFIG__ ?? {};
const clientId = cfg.azureClientId || import.meta.env.VITE_AZURE_CLIENT_ID || '';
const tenantId = cfg.azureTenantId || import.meta.env.VITE_AZURE_TENANT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin + '/login',
  },
  cache: {
    // localStorage (not sessionStorage) so the popup window — which has its
    // own sessionStorage in many browsers — can read the PKCE code-verifier
    // written by the opener and complete the popup flow. With sessionStorage,
    // the popup's handleRedirectPromise throws no_token_request_cache_error,
    // clears the hash as a side effect, and the opener's polling then misses
    // the response and silently times out (monitor_window_timeout).
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
};
